import React from 'react';
import LocationTemplate from './LocationTemplate';

const WintonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Winton"
      stateName="North Carolina"
      countyName="Hertford"
      zipCodes={["27986"]}
      latitude={36.3940}
      longitude={-76.9319}
      population={769}
      historicalFact="Incorporated in 1887, named after early settler Colonel Richard Winton."
      nearbyTowns={[
        "Ahoskie, NC",
        "Murfreesboro, NC",
        "Gatesville, NC",
        "Como, NC",
        "Harrellsville, NC",
        "Cofield, NC",
        "Powellsville, NC",
        "Suffolk, VA"
      ]}
    />
  );
};

export default WintonPage;